module.exports = __webpack_public_path__ + "50900259db81c9b9c00c1fb109cb0bfd.jpg";